(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('countdownTimer', (targetTimestamp) => ({
      target: targetTimestamp * 1000,
      circumference: 2 * Math.PI * 46,
      timer: null,
      units: [
        { key: 'days', label: 'days', max: 35, value: 0, progress: 0, display: '0' },
        { key: 'hours', label: 'hours', max: 24, value: 0, progress: 0, display: '00' },
        { key: 'minutes', label: 'minutes', max: 60, value: 0, progress: 0, display: '00' },
        { key: 'seconds', label: 'seconds', max: 60, value: 0, progress: 0, display: '00' },
      ],
      init() {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      },
      destroy() {
        if (this.timer) clearInterval(this.timer);
      },
      tick() {
        let diff = Math.floor((this.target - Date.now()) / 1000);
        if (diff < 0) diff = 0;

        const values = {
          days: Math.floor(diff / 86400),
          hours: Math.floor((diff % 86400) / 3600),
          minutes: Math.floor((diff % 3600) / 60),
          seconds: diff % 60,
        };

        this.units.forEach((unit) => {
          unit.value = values[unit.key];
          // Arc length reflects the remaining value (matches the Figma frame):
          // the arc opens/shrinks as the unit counts down toward zero.
          const ratio = unit.value / unit.max;
          unit.progress = Math.min(1, Math.max(0, ratio));
          unit.display = unit.key === 'days' ? String(unit.value) : String(unit.value).padStart(2, '0');
        });
      },
      offset(unit) {
        return this.circumference * (1 - unit.progress);
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
